export default function loopPlayTooltip(chart, options) {
    var {
        interval = 3000, // 轮播间隔
            seriesIndex = 0, // 参与轮播的系列
            reverse = false, // 倒序播放
    } = options

    if (!chart) {
        return {}
    }

    var timer = null,
        curDataIndex = -1,
        finished = false

    // 开启轮播
    function startLoop(chartOptions) {
        // 等同于reStart
        stopLoop()

        // 基础数据
        var computedOptions = chartOptions || chart.getOption() || {},
            dataLength = computedOptions.series[0].data.length || 0,
            count = curDataIndex < 0 ? (reverse ? dataLength - 1 : 0) : curDataIndex + 1,
            isAxisTooltip = false,
            tooltipOption = computedOptions.tooltip || {}

        if (tooltipOption && tooltipOption[0]) {
            tooltipOption = tooltipOption[0]
        }

        isAxisTooltip = tooltipOption.trigger == "axis"

        if (finished == false) {
            // 鼠标进入时，停止轮播
            chart.on('mouseover', onMouseover)

            // 鼠标离开时，开始轮播
            chart.on('mouseout', onMouseout)

            finished = true
        }

        // 定时器
        timer = setInterval(function() {
            // 取消之前的高亮
            chart.dispatchAction({
                type: 'downplay',
                seriesIndex,
            })

            // 高亮
            chart.dispatchAction({
                type: 'highlight',
                seriesIndex,
                dataIndex: count % dataLength
            })

            // 显示tooltip
            var tooltipSeries = seriesIndex
            // 轴触发选其一
            if (isAxisTooltip && seriesIndex.length) {
                tooltipSeries = seriesIndex[0]
            }

            chart.dispatchAction({
                type: 'showTip',
                seriesIndex: tooltipSeries,
                dataIndex: count % dataLength
            })

            // 当前高亮数据索引
            curDataIndex = count % dataLength

            if (reverse) {
                count--
                if (count < 0) {
                    count = dataLength - 1
                }
            } else {
                count++
            }

            // console.log(count % dataLength)
        }, interval)
    }

    // 停止轮播
    function stopLoop() {
        if (timer) {
            clearInterval(timer)
            timer = null
        }
    }

    // 清理轮播
    function clear() {
        if (timer) {
            clearInterval(timer)
        }

        if (chart) {
            chart.off('mouseover', onMouseover)
            chart.off('mouseout', onMouseout)
        }

        finished = false
    }

    function onMouseover(params) {
        if (params.dataIndex != curDataIndex) {
            chart.dispatchAction({
                type: 'downplay',
                seriesIndex,
                dataIndex: curDataIndex,
            })

            curDataIndex = params.dataIndex
        }

        stopLoop()
    }

    function onMouseout() {
        startLoop()
    }
    // 启用轮播
    startLoop()

    // 返回控制台
    return {
        startLoop,
        stopLoop,
        clear,
    }
}